// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c6fd2185","732":"9ed51019","977":"a56f8ab1"}[chunkId] + ".chunk.js";
};